/* eslint-disable import/prefer-default-export */
import { makeVar } from '@apollo/client';

export const npsSurveyTriggerVar = makeVar(false);
